
 document.addEventListener('DOMContentLoaded', () => {
            async function getCartItems() {
                try {
                    const response = await axios.get('/cart.js');
                    if (response.status !== 200) throw new Error("Failed to fetch cart items.");
                    return response.data.items;
                } catch (error) {
                    console.error("Error fetching cart items:", error);
                    return [];
                }
            }

            function createWhatsAppMessage(items) {
                let message = "Productos en mi carrito:\n";
                items.forEach(item => {
                    const currency = item.currency || '$'; // Asigna el signo del dólar como valor por defecto
                    message += `CANT: ${item.quantity} x ${item.title} - ${item.price / 100} ${currency}\n`;
                });
                return message;
            }

            function redirectToWhatsApp(message) {
                const phoneNumber = "+584245136289"; // Replace with your WhatsApp number
                const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                window.location.href = url;
            }

            document.getElementById('send-to-whatsapp').addEventListener('click', async () => {
                const items = await getCartItems();
                if (items.length === 0) {
                    alert("No hay productos en este carrito.");
                    return;
                }
                const message = createWhatsAppMessage(items);
                redirectToWhatsApp(message);
            });

            async function displayCartItems() {
                const items = await getCartItems();
                const cartItemsDiv = document.getElementById('cart-items');
                if (!cartItemsDiv) {
                    console.error("Element with ID 'cart-items' not found.");
                    return;
                }
                cartItemsDiv.innerHTML = ""; // Clear previous items
                if (items.length === 0) {
                    cartItemsDiv.textContent = "Tu carrito está vacío.";
                    return;
                }
                items.forEach(item => {
                    const currency = item.currency || '$'; // Asigna el signo del dólar como valor por defecto
                    const itemDiv = document.createElement('div');
                    itemDiv.textContent = `CANT: ${item.quantity} x ${item.title} - ${item.price / 100} ${currency}`;
                    cartItemsDiv.appendChild(itemDiv);
                });
            }

            displayCartItems();
        });